import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CorporateClient from "../components/CorporateClient";

const CorporateClientPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Corporate Client' />

        {/* BlankPageLayer */}
        <CorporateClient />
      </MasterLayout>
    </>
  );
};

export default CorporateClientPage;

